export const GET_ALL_REQUEST = 'GET_ALL_REQUEST'
export const GET_ALL_SUCCESS = 'GET_ALL_SUCCESS'
export const GET_ALL_FAIL = 'GET_ALL_FAIL'

export const ADD_TO_CART_REQUEST = 'ADD_TO_CART_REQUEST'
export const ADD_TO_CART_SUCCESS = 'ADD_TO_CART_SUCCESS'
export const ADD_TO_CART_FAIL = 'ADD_TO_CART_FAIL'
export const REMOVE_FROM_CART_REQUEST = 'REMOVE_FROM_CART_REQUEST'
export const REMOVE_FROM_CART_SUCCESS = 'REMOVE_FROM_CART_SUCCESS'
export const REMOVE_FROM_CART_FAIL = 'REMOVE_FROM_CART_FAIL'

export const TOTAL_PRICE = 'TOTAL_PRICE'

export const CLEAR_CART = 'CLEAR_CART'
export const CLEAR_MESSAGE_ERROR = 'CLEAR_MESSAGE_ERROR'